import * as React from 'react';
import { Select } from "antd";
import { Contract, TreeData } from "tree-wallet-client";
import { FormInstance } from "antd/lib/form";
import SearchableSelect from "../../Component/SearchableSelect";

const { Option } = Select;

interface TreeTypeSelectProps {
  treeData: any;
  contract: Contract;
  name: string;
  formRef: React.RefObject<FormInstance>;
  formSetState: Function;
}

const defaultLanguage = 'spanish';
const fallbackLanguage = 'latin';

export default function TreeTypeSelect(props: TreeTypeSelectProps) {
  const { treeData, contract, formRef, name, formSetState } = props;

  const filterOption = (input: string, option: any) => {
    // The value is the position in the sorted list, so 0 is a real value
    if (option?.value === undefined) {
      return false;
    }
    try {
      const treeIdx = parseInt(option?.value.toString());
      const translations = treeData && treeData[treeIdx].translations;
      const language = translations[contract.preferences.language]
        ? translations[contract.preferences.language]
        : translations[defaultLanguage];
      if (!language) {
        return translations[fallbackLanguage]?.toLowerCase().indexOf(input.toLowerCase()) > -1;
      }
      return language.toLowerCase().indexOf(input.toLowerCase()) > -1
        || translations[fallbackLanguage].toLowerCase().indexOf(input.toLowerCase()) > -1;
    } catch (err) {
      return false;
    }
  }

  const sortOptions = (treeData: TreeData[]) => {
    // In place on purpose: the option value is the index into this array 
    // (see `TreeForm` which resolves the chosen tree type as `treeData[value]`)
    return treeData?.sort((a: TreeData, b: TreeData) => {
      try {
        const language = a.translations[contract.preferences.language]
          ? contract.preferences.language
          : fallbackLanguage;

        return a.translations[language].toLowerCase() > b.translations[language].toLowerCase() ? 1 : -1;
      } catch (err) {
        console.error(err, [a, b]);
        return a.translations[fallbackLanguage].toLowerCase() > b.translations[fallbackLanguage].toLowerCase() ? 1 : -1;
      }
    }).map((data: TreeData, idx: number) => {
      try {
        const language = data.translations[contract.preferences.language]
          ? contract.preferences.language
          : fallbackLanguage;
        return <Option value={idx} translations={data.translations} key={idx + '_' + language}>
          <span style={{
            fontWeight: '450',
            textTransform: 'capitalize'
          }}>
            {data.translations[language]}
          </span>
          <span style={{
            marginLeft: '10px',
            fontStyle: 'italic',
            textTransform: 'capitalize'
          }}>
            ({data.translations[fallbackLanguage]})
          </span>
        </Option>
      } catch (err) {
        console.error(err, { data, idx });
        return <Option value={idx} translations={data.translations} key={`${idx}_${fallbackLanguage}`}>
          {data.translations[fallbackLanguage]}
        </Option>
      }
    })
  };

  // The scroll container, the search and the keyboard handling all come from `SearchableSelect`
  return <SearchableSelect
    loading={treeData === undefined}
    size={'large'}
    placeholder={treeData === undefined ? "Loading..." : "Select a tree"}
    optionFilterProp="children"
    filterOption={filterOption}
    onChange={(value: number) => {
      formRef.current && formRef.current.setFieldsValue({ [name]: value });
      formSetState({ [name]: value });
    }}
  >
    {sortOptions(treeData)}
  </SearchableSelect>;
}